import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getRequests } from "store/actions";
import Table from "./Table";

const Requests = () => {
  const { requests, loading, error } = useSelector((state) => state.requests);
  const dispatch = useDispatch();
  const { formatMessage, locale } = useIntl();

  useEffect(() => {
    dispatch(getRequests());
  }, [dispatch]);

  // error
  useEffect(() => {
    if (error) {
      toast.error(formatMessage({ id: "sendingErrorMessage" }), {
        position: locale === "ar" ? "bottom-left" : "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [error, formatMessage, locale]);

  return (
    <>
      <div className="categories-wrap">
        {/* <ControlArea
          btnTxt={<FormattedMessage id={"addRequest"} />}
          cardTxt={<FormattedMessage id={"requests"} />}
          icon={Icon}
          url="/requests/add"
        /> */}
        <Table data={requests} loading={loading} />
      </div>
    </>
  );
};

export default Requests;
